// extracted by mini-css-extract-plugin
export default {"button":"gl-z","reviewSort":"hl-z"};